import { render } from "./BriefcaseJobIcon.vue?vue&type=template&id=008bb9ce&scoped=true"
import script from "./BriefcaseJobIcon.vue?vue&type=script&lang=js"
export * from "./BriefcaseJobIcon.vue?vue&type=script&lang=js"

import "./BriefcaseJobIcon.vue?vue&type=style&index=0&id=008bb9ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008bb9ce"]])

export default __exports__